import { render } from "./IntroductionSlide.vue?vue&type=template&id=2f381c26&scoped=true"
import script from "./IntroductionSlide.vue?vue&type=script&lang=js"
export * from "./IntroductionSlide.vue?vue&type=script&lang=js"

import "./IntroductionSlide.vue?vue&type=style&index=0&id=2f381c26&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f381c26"]])

export default __exports__